import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "border-t-1 absolute bottom-0 z-10 border-white" }
const _hoisted_2 = { class: "w-screen bg-red-500 p-3 lg:flex lg:items-center lg:justify-between" }
const _hoisted_3 = { class: "flex items-center justify-center" }
const _hoisted_4 = ["id"]
const _hoisted_5 = {
  key: 0,
  class: "flex items-center justify-center pt-1 md:pr-2"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-normal text-white" }, " Have a query? Message us in ", -1)
const _hoisted_7 = {
  class: "pl-2",
  href: "https://www.facebook.com/DailyStocksInfo/",
  target: "_blank"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Facebook page", -1)
const _hoisted_10 = { class: "p-2" }
const _hoisted_11 = { class: "text-center text-sm sm:text-base" }

import {
  computed,
} from 'vue';
import {
  useRouter,
} from 'vue-router';
import DevelopedByWithLogo from '@/components/App/DevelopedByWithLogo.vue';
import {
  useStore,
} from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterComponent',
  setup(__props) {


const authStore = useStore.auth;
const router = useRouter();

const user = computed(() => authStore.user);

const currentYear = new Date().getFullYear();

const availableButtons = computed(() => [
  {
    _id: 0, fieldName: 'Privacy', path: '/privacy-policy', visible: true,
  },
  {
    _id: 1, fieldName: 'Terms', path: '/terms-of-service', visible: true,
  },
  {
    _id: 2, fieldName: 'Contact', path: '/contact', visible: !!user.value,
  },
]);

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableButtons), (btn) => {
          return (_openBlock(), _createElementBlock("div", {
            id: btn.fieldName === 'Terms' ? 'footer-terms' : undefined,
            key: btn._id,
            class: "px-[1px]"
          }, [
            (btn.visible)
              ? (_openBlock(), _createBlock(_component_RouterLink, {
                  key: 0,
                  class: _normalizeClass(["rounded py-3 px-2 text-sm font-normal text-white hover:bg-red-400", {'bg-red-400': btn.path === _unref(router).currentRoute.value.fullPath}]),
                  to: btn.path
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(btn.fieldName), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "class"]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_4))
        }), 128))
      ]),
      (!_unref(user))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("a", _hoisted_7, [
              _createElementVNode("img", {
                src: require('@/assets/socials/fb-logo.png'),
                alt: "fb-logo"
              }, null, 8, _hoisted_8),
              _hoisted_9
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("p", _hoisted_11, " Copyright © " + _toDisplayString(_unref(currentYear)) + " Daily Stocks, all rights reserved ", 1),
      _createVNode(DevelopedByWithLogo, { class: "pt-2" })
    ])
  ]))
}
}

})